module.exports = __webpack_public_path__ + "img/al-image.7e5ced86.png";